// extracted by mini-css-extract-plugin
module.exports = {"productMain":"SelectionVisualizer_productMain__3lT9t","dbrand":"SelectionVisualizer_dbrand__x3cje"};